import { NewDropoffProvider, RewardProvider } from '../../data/api'
import DropOffTypeProvider from '../../data/api/DropOffTypeProvider'
import TenantProvider from '../../data/api/TenantProvider'
import WasteTypeProvider from '../../data/api/WasteTypeProvider'
import GeolocationProvider from '../../data/geolocation/GeolocationProvider'
import DropOffProvider from '../../data/woosmap/DropOffProvider'
import MultisearchProvider from '../../data/woosmap/MultisearchProvider'
import WoosmapGeocodingProvider from '../../data/woosmap/WoosmapGeocodingProvider'
import { IDropOffProvider } from '../../domain/providers/DropOffProvider'
import { IDropOffTypeProvider } from '../../domain/providers/DropOffTypeProvider'
import { IGeocodingProvider } from '../../domain/providers/IGeocodingProvider'
import { IGeolocationProvider } from '../../domain/providers/IGeolocationProvider'
import { INewDropoffProvider } from '../../domain/providers/INewDropoffProvider'
import { IRewardProvider } from '../../domain/providers/IRewardProvider'
import { IMultisearchProvider } from '../../domain/providers/MultisearchProvider'
import { ITenantProvider } from '../../domain/providers/TenantProvider'
import { IWasteTypeProvider } from '../../domain/providers/WasteTypeProvider'
import { BACKEND_API_URL, WOOSMAP_PUBLIC_KEY } from '../config'

export interface IDependencies {
  dropOffProvider: IDropOffProvider
  tenantProvider: ITenantProvider
  dropOffTypeProvider: IDropOffTypeProvider
  wasteTypeProvider: IWasteTypeProvider
  geolocationProvider: IGeolocationProvider
  geocodingProvider: IGeocodingProvider
  newDropoffProvider: INewDropoffProvider
  multisearchProvider: IMultisearchProvider
  rewardProvider: IRewardProvider
}

export const createDependencies = (): IDependencies => {
  const tenantProvider = new TenantProvider(BACKEND_API_URL)
  const wasteTypeProvider = new WasteTypeProvider(BACKEND_API_URL)
  const dropOffTypeProvider = new DropOffTypeProvider(BACKEND_API_URL)
  const dropOffProvider = new DropOffProvider()
  const geolocationProvider = new GeolocationProvider(navigator)
  const geocodingProvider = new WoosmapGeocodingProvider(WOOSMAP_PUBLIC_KEY)
  const newDropoffProvider = new NewDropoffProvider(BACKEND_API_URL)
  const multisearchProvider = new MultisearchProvider()
  const rewardProvider = new RewardProvider(BACKEND_API_URL)

  return {
    tenantProvider,
    dropOffProvider,
    dropOffTypeProvider,
    wasteTypeProvider,
    geolocationProvider,
    geocodingProvider,
    newDropoffProvider,
    multisearchProvider,
    rewardProvider
  }
}
